import { createStyles } from "antd-style";

export const useProductGuideStyles = createStyles(({ token, css }: any) => ({
  stepIcon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  `,
  logo: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
    width: 152px;
    height: 96px;
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
    box-sizing: border-box;
    border-radius: 4px;
    border: 2px solid ${token.ColorFigmaComplementaryBlue50};
  `,
  altriaContainer: css`
    max-width: 800px;
    margin: 0 auto;

    li {
      &::marker {
        content: "-";
      }
    }
  `,
  cStoreOfficeContainer: css`
    background: ${token.ColorFigmaComplementaryBlue50};

    * {
      color: ${token.ColorFigmaNeutralWhiteWhite100} !important;
    }
  `,
}));
